import React from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import history from '~/services/history';
import { Container } from './style';

function BackButton() {
  return (
    <Container>
      <div className="voltar">
        <button type="button" onClick={() => history.goBack()}>
          <IoMdArrowBack size={15} /> Voltar
        </button>
      </div>
    </Container>
  );
}

export default BackButton;
export { BackButton };
